
import Vue from 'vue'
import mixin from '@/mixin'
import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import axios from 'axios'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
import { db, storageRef, auth } from '@/main'
@Component
export default class DeleteAdmin extends mixins(mixin) {
  @Prop() admin
  showDialog = false

  async deleteAdmin() {
    try {
      this.showNotification(
        'loading',
        'Eliminando administrador',
        'Un momento por favor'
      )
      let isTheSame = false
      if (auth.currentUser?.uid == this.admin.uid) {
        isTheSame = true
      }
      const url = URL_CLOUD_FUNCTIONS + 'deleteAdmin'
      const resp = await axios.post(url, this.admin)
      console.log(resp)
      this.showNotification(
        'success',
        'Administrador eliminado',
        'El administrador fue eliminado con éxito'
      )
      
      this.showDialog = false

      if (isTheSame) {
        this.logOut()
      }
    } catch (error) {
      this.showNotification(
        'fail',
        'Error',
        'No se pudo eliminar el administrador. Intenta nuevamente'
      )
      console.log(error)
      this.showDialog = false
    }
  }
}
